import useCollection from "./useCollection"

export default function useFieldLookupValues(
  field,
  subjectType,
  subjectId,
  swrOptions = {}
) {
  const isLookupField = field.kind === "Lookup"
  const hasParent = subjectType && subjectId
  const url = `/fields/${field.id}/lookup_values`

  function cacheKey() {
    if (!isLookupField) {
      return null
    } else if (hasParent) {
      return [url, subjectType, subjectId]
    } else {
      return url
    }
  }

  function queryParams() {
    if (hasParent) {
      return { parent_type: subjectType, parent_id: subjectId }
    } else {
      return {}
    }
  }

  return useCollection({
    key: cacheKey(),
    url,
    params: queryParams(),
    swrOptions,
  })
}
